import { computed, observable, action } from 'mobx';
import { helpers } from '@kurtosys/ksys-app-template/dist';
import { Translation, Translations } from '../models/translations';
import { ConfigStore, BaseStore, DataStore } from '.';

export class TranslationStore extends BaseStore {
    @computed
    public get translationHelper(): helpers.TranslationHelper {
        return new helpers.TranslationHelper(
            this.translations,
            this.fallbackTranslations
        );
    }

    @observable.ref
    private translationData: Array<Translation> = [];

    @observable.ref
    private translationsByCulture: Map<string, Translations> = new Map();

    @computed
    private get data(): DataStore {
        if (this.stores) {
            return this.stores.data;
        }
        return;
    }

    @computed
    private get config(): ConfigStore {
        if (this.data) {
            return this.data.config;
        }
        return;
    }

    @computed
    private get baseCulture() {
        return this.config && this.config.sourceCulture;
    }

    @computed
    private get defaultCulture() {
        return this.config && this.config.defaultCulture;
    }

    @computed
    private get culture() {
        return this.data && this.data.culture;
    }

    @computed
    private get translations() {
        return this.translationsByCulture.get(this.culture) || {};
    }

    @computed
    private get fallbackTranslations() {
        return this.translationsByCulture.get(this.defaultCulture) || {};
    }

    @action
    public setTranslationData(data) {
        this.translationData = data;
        this.setTranslationsForCulture(this.culture);
        this.setTranslationsForCulture(this.defaultCulture);
    }

    public translate = (key: string, placeholders?: any) => {
        return this.translationHelper.translate(key, placeholders);
    };

    @action
    private setTranslationsForCulture(targetCulture: string) {
        if (targetCulture) {
            const byCulture = new Map(this.translationsByCulture);
            byCulture.set(
                targetCulture,
                this.getTranslationsMapForCulture(targetCulture)
            );
            // update observable ref
            this.translationsByCulture = byCulture;
        }
    }

    private getTranslationsMapForCulture(targetCulture: string) {
        return this.translationData
            .filter(translationRecord => {
                return (
                    translationRecord.translationCulture === targetCulture &&
                    translationRecord.culture === this.baseCulture
                );
            })
            .reduce((mapped, translationRecord) => {
                const { phrase, translation } = translationRecord;
                mapped[phrase] = translation;
                return mapped;
            }, {});
    }
}



// WEBPACK FOOTER //
// ./src/stores/TranslationStore.ts